// Tab1.js
import React, { useEffect, useState } from "react";
import api from "../Api/base";
import {
	Box,
	Button,
	IconButton,
	Paper,
	Skeleton,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableFooter,
	TableHead,
	TablePagination,
	TableRow,
	Typography,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Chip,
	Divider,
	Pagination,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import config from "../config/config";
import { LoadingButton } from "@mui/lab";
import PrescriptionPreview from "./PrescriptionPreview";
import { styled } from "@mui/material/styles";
import CustomTablePaginationActions from "../components/Tables/TablePaginationActions";
import { ArrowBack, ExpandMore, Preview } from "@mui/icons-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faEye } from "@fortawesome/free-solid-svg-icons";
import { parse, format } from "date-fns";
import { bn } from "date-fns/locale";
import { setLoading } from "../App";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	"&:last-child td, &:last-child th": {
		border: 0,
	},
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: theme.palette.grey[300],
		// color: theme.palette.common.white,
		fontWeight: "bold",
		fontSize: 16,
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 14,
	},
}));

const Record = () => {
	const [records, setRecords] = useState([]);
	const [selectedRecord, setSelectedRecord] = useState(null);

	const [cols, setCols] = useState([]);
	const [initializing, setInitializing] = useState(true);

	const fetchRecords = async () => {
		const result = await api.post(
			"https://tib60ktrrj.execute-api.us-east-1.amazonaws.com/prod",
			{
				task: "get_prescriptionList",
			}
		);
		if (result.success) {
			const sortedRecords = result.data.sort((a, b) => {
				const dateA = new Date(a.creation_date);
				const dateB = new Date(b.creation_date);
				return dateB - dateA; // Sort in descending order
			});
			setRecords(sortedRecords);
		} else {
			console.log("Error fetching records");
		}
		setInitializing(false);
		setLoading(false);
	};

	const handleRecordClick = async (record) => {
		if (record.advice) return;
		const res = await api.post(
			"https://tib60ktrrj.execute-api.us-east-1.amazonaws.com/prod",
			{
				task: "get_prescription",
				creation_date: record.creation_date,
			}
		);

		console.log("New record:", res);
		if (res.success) {
			// setSelectedRecord({
			// 	age: JSON.parse(res.data[0].question_answer).formData.age,
			// 	gender: JSON.parse(res.data[0].question_answer).formData.gender,
			// 	creation_date: record.creation_date,
			// 	advice: JSON.parse(res.data[0].advice),
			// });
			setRecords(
				records.map((item) => {
					if (item.creation_date === record.creation_date) {
						return {
							...item,
							age: JSON.parse(res.data[0].question_answer)
								.formData.age,
							gender: JSON.parse(res.data[0].question_answer)
								.formData.gender,
							advice: JSON.parse(res.data[0].advice),
						};
					}
					return item;
				})
			);
		} else {
			console.log("Error fetching record");
		}
	};

	const [data, setData] = useState([]);
	const [page, setPage] = useState(1);
	const itemsPerPage = 9;
	const pagecount = Math.ceil(records.length / itemsPerPage);
	useEffect(() => {
		const start = (page - 1) * itemsPerPage;
		const end = Math.min(start + itemsPerPage, records.length);
		setData(records.slice(start, end));
	}, [page, records]);
	const handlePagination = (event, value) => {
		setPage(value);
	};

	useEffect(() => {
		fetchRecords();
	}, []);
	const TimeConverter = (dateTime24) => {
		const parsedDate = parse(dateTime24, "yyyy-MM-dd HH:mm:ss", new Date());
		const formattedTime = format(parsedDate, "MMMM dd, yyyy, hh:mm:ss a");

		return <div>{formattedTime}</div>;
	};
	return (
		<Box
			className="max-w-2xl mx-auto px-5 py-3"
			style={{ minHeight: `calc(100vh - ${config.topbarHeight}px)` }}
		>
			<h1 className="text-3xl font-bold text-center mt-4 mb-6">
				আমার ব্যাবস্থাপত্র
			</h1>
			<Box className="w-full flex flex-col gap-2">
				{records.map((record, index) => (
					<Accordion
						key={index}
						sx={{ mb: 1 }}
						className="w-full"
						onChange={() => handleRecordClick(record)}
					>
						<AccordionSummary
							expandIcon={
								<IconButton>
									<ExpandMore />
								</IconButton>
							}
							aria-controls={`panel${index}-content`}
							id={`panel${index}-header`}
						>
							<Box
								sx={{
									display: "flex",
									justifyContent: "space-between",
									width: "100%",
									alignItems: "center",
								}}
							>
								<Box>
									<Typography
										variant="subtitle1"
										sx={{ fontWeight: "medium" }}
									>
										{TimeConverter(record.creation_date)}
									</Typography>
								</Box>
							</Box>
						</AccordionSummary>
						<Divider />
						<AccordionDetails>
							{/* <Divider className="b-4" /> */}
							<PrescriptionPreview {...records[index]} />
						</AccordionDetails>
					</Accordion>
				))}
				<div className="mt-10 flex justify-center bottom-0 left-0 right-0 pt-4">
					<Pagination
						size="medium"
						count={pagecount}
						color="primary"
						onChange={handlePagination}
						siblingCount={1}
						page={page}
					/>
				</div>
			</Box>
		</Box>
	);
};

export default Record;

// Tab2.js and Tab3.js similar to Tab1.js

{
	/* <Box className="flex flex-col">
	<Box className="max-w-2xl px-4">
		<Button
			variant="outlined"
			// color="success"
			fullWidth
			onClick={() => setSelectedRecord(null)}
			startIcon={<ArrowBack />}
		>
			তালিকায় ফেরত যান
		</Button>
	</Box>
	<PrescriptionPreview {...selectedRecord} />
</Box>; */
}
{
	/* records.map((record, index) => (
					<LoadingButton
						variant="contained"
						key={index}
						onClick={() => handleRecordClick(record)}
						loading={loading}
					>
						<h2>{record.creation_date}</h2>
					</LoadingButton>
				)) */
}
// (
{
	/* <TableContainer component={Paper}>
<Table aria-label="custom pagination table">
<TableHead>
	<TableRow>
		<StyledTableCell className="!py-3">
			<div className="flex flex-row gap-4 justify-end">
				<Skeleton
					variant="text"
					height={30}
					className="w-[5%]"
				/>
				<Skeleton
					variant="text"
					height={30}
					className="w-[30%]"
				/>
				<Skeleton
					variant="text"
					height={30}
					className="w-[30%]"
				/>
				<Skeleton
					variant="text"
					// width={"10rem"}
					height={30}
					className="w-[20%]"
				/>
				<Skeleton
					variant="text"
					// width={"10rem"}
					height={30}
					className="w-[15%]"
				/>
			</div>
		</StyledTableCell>
	</TableRow>
</TableHead>
<TableBody>
	{[...Array(5).keys()].map((index) => (
		<TableRow>
			<TableCell className="!py-3">
				<div className="flex flex-row gap-4 justify-end">
					<Skeleton
						variant="text"
						height={30}
						className="w-[5%]"
					/>
					<Skeleton
						variant="text"
						height={30}
						className="w-[30%]"
					/>
					<Skeleton
						variant="text"
						height={30}
						className="w-[30%]"
					/>
					<Skeleton
						variant="text"
						// width={"10rem"}
						height={30}
						className="w-[20%]"
					/>
					<Skeleton
						variant="text"
						// width={"10rem"}
						height={30}
						className="w-[15%]"
					/>
				</div>
			</TableCell>
		</TableRow>
	))}
</TableBody>

<TableFooter>
	<TableRow>
		<TableCell className="!py-3">
			<div className="flex flex-row gap-4 justify-end">
				<Skeleton
					variant="text"
					height={30}
					className="w-40"
				/>
				<Skeleton
					variant="text"
					height={30}
					className="w-24"
				/>
				<Skeleton
					variant="text"
					// width={"10rem"}
					height={30}
					className="w-12 md:w-32"
				/>
			</div>
		</TableCell>
	</TableRow>
</TableFooter>
</Table>
</TableContainer> */
}
// ) : (
{
	/* <TableContainer component={Paper}>
<Table aria-label="custom pagination table">
<TableHead>
	<TableRow>
		<StyledTableCell>
			<div className="flex flex-row w-full">
				{Object.entries(cols).map(
					([key, width]) => (
						<div
							key={key}
							style={{
								width: width,
							}}
						>
							{convertFromSnake(key)}
						</div>
					)
				)}
			</div>
		</StyledTableCell>
	</TableRow>
</TableHead>
<TableBody>
	{(rowsPerPage > 0
		? rows.slice(
				page * rowsPerPage,
				page * rowsPerPage + rowsPerPage
			)
		: rows
	).map((row) => (
		<TableRow
			hover
			role="checkbox"
			tabIndex={-1}
			key={row.id}
			style={{
				cursor: "pointer",
			}}
		>
			<TableCell
				onClick={() =>
					navigate("/profiles/edit#" + row.id)
				}
			>
				<div className="flex flex-row w-full">
					{Object.keys(row).map((key) => (
						<div
							key={key}
							className={`truncate w-[${cols[key]}]`}
						>
							<Typography noWrap>
								{row[key]}
							</Typography>
						</div>
					))}
				</div>
			</TableCell>
		</TableRow>
	))}
	{emptyRows > 0 && (
		<TableRow style={{ height: 57 * emptyRows }}>
			<TableCell colSpan={6} />
		</TableRow>
	)}
</TableBody>
<TableFooter>
	<StyledTableRow>
		<TablePagination
			rowsPerPageOptions={[
				5,
				10,
				25,
				{ label: "All", value: -1 },
			]}
			colSpan={3}
			count={rows.length}
			rowsPerPage={rowsPerPage}
			page={page}
			slotProps={{
				select: {
					inputProps: {
						"aria-label": "rows per page",
					},
					native: true,
				},
			}}
			onPageChange={handleChangePage}
			onRowsPerPageChange={
				handleChangeRowsPerPage
			}
			ActionsComponent={
				CustomTablePaginationActions
			}
		/>
	</StyledTableRow>
</TableFooter>
</Table>
</TableContainer> */
}
// )
